import { Box, css } from '@mui/material'
import styled from '@emotion/styled'

export const TitleFilterRow = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    @media (max-width: ${theme.screenSizes.laptop}) {
      flex-direction: column;
      align-items: flex-start;
    }
  `}
`

export const TabsBox = styled(Box)`
  display: flex;
  justify-content: flex-end;
`

export const Buttons = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    margin-top: 32px;
    justify-content: flex-end;

    @media (max-width: ${theme.screenSizes.laptop}) {
      gap: 16px;
    }
  `}
`
